export default __webpack_public_path__ + "static/media/iconUp.9e338162.svg";